import { Text } from 'foundations-components/components/Text';
import { MEDIA_PLAYER_COLORS } from '../../constants/Colors';
import { secondsToFormattedTime } from '../../../utils/dateTimeFormatUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaPlayerTime = ({
  time,
  textAlign
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    display: "block",
    textAlign: textAlign,
    color: MEDIA_PLAYER_COLORS.TIMELINE_TEXT_COLOR,
    children: /*#__PURE__*/_jsx("strong", {
      children: secondsToFormattedTime(time)
    })
  });
};